<template>
  <div class="container">
    <card>
      <div>
        <div class="line-item">
          <div class="l-txt" >学历</div>
          <div class="r-txt">{{educationalLevel}}</div>
        </div>
        <rline></rline>
      </div>
      <div v-if="majorLevel">
        <div class="line-item">
          <div class="l-txt" >专业</div>
          <div class="r-txt">{{majorLevel}}</div>
        </div>
        <rline></rline>
      </div>
      <div v-if="schoolLevel">
        <div class="line-item">
          <div class="l-txt" >毕业院校</div>
          <div class="r-txt">{{schoolLevel}}</div>
        </div>
        <rline></rline>
      </div>
    </card>

  </div>
</template>
<script>
    import rline from '../travelAgency/components/line'
    import card from '../travelAgency/components/card'
    export default {
        components: {
            rline,
            card
        },

        data () {
            return {
                educationalLevel: '',
                majorLevel: '',
                schoolLevel: ''
            };
        },

        computed: {},

        watch: {},

        methods: {

        },

        mounted () {
            this.educationalLevel = this.$route.query.educationalLevel
            this.majorLevel = this.$route.query.majorLevel
            this.schoolLevel = this.$route.query.schoolLevel
        },
        created () {}
    }
</script>
<style scoped lang="less">
  .container{
    height: 100vh;
    background-color: @base-bgcolor;
    padding:16px 12px;
    box-sizing: border-box;
    .line-item{
      padding:16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .l-txt{
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(153,153,153,1);
      }
            .r-txt{
          font-size:14px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(51,51,51,1);
      }
    }
  }
</style>
